import API from 'api';
import React, { useCallback, useEffect, useState } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';
import { useForm } from 'react-hook-form';
import toast from "react-hot-toast";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete,
  LoadScript,
} from "@react-google-maps/api";
const GarageModal = ({ isOpen, onClose,
  handleSubmitForm, globalData, }) => {
  const [map, setMap] = useState(null);
  const [lat, setLat] = useState(0);
  const [long, setLong] = useState(0);
  const [autocompleted, setAutocompleted] = useState();
  const [locationText, setLocationText] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const [dropDownSelection, setDropDownSelection] = useState(false);
  const [placeChanged, setPlaceChanged] = useState(null);
  // Define the marginTop value to adjust the modal position
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors, isSubmitting },
    clearErrors,
  } = useForm();
  const { ref } = usePlacesWidget({
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY,
    onPlaceSelected: (place) => {
      setDropDownSelection(true);
      setLocationText(place.formatted_address);
      onPlaceChangedNew(
        place.geometry.location.lat(),
        place.geometry.location.lng(),
        place.formatted_address
      );
    },
    options: {
      types: [],
      componentRestrictions: { country: "AE" },
    },
  });
  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds({ lat: lat, lng: long });
    map.fitBounds(bounds);
    setMap(map);
  }, []);
  const onLoading = (autocomplete) => {
    setAutocompleted(autocomplete);
  };
  const onPlaceSelected = (place) => {
    //   setDropDownSelection(true)
    setLocationText(place.formatted_address);
    onPlaceChangedNew(
      place.geometry.location.lat(),
      place.geometry.location.lng(),
      place.formatted_address
    );
  };

  useEffect(() => {
    if (placeChanged) {
      onPlaceSelected();
    }
  }, [placeChanged]);
  const getCurrentLocation = (isFirst = false) => {
    locateCurrentPosition()
      .then((position) => {
        const lat = Number(position.coords.latitude);
        const lang = Number(position.coords.longitude);
        setLat(Number(lat));
        setLong(Number(lang));
        if (isFirst && hadLocation) {
          const latCurrent = Number(hadLocation.lat);
          const langCurrent = Number(hadLocation.lang);
          getCoordinates(latCurrent, langCurrent, 10);
          setCheckCenter(false);
        } else {
          setLatTemp(Number(lat));
          setLongTemp(Number(lang));
        }

        onPlaceChangedNew(lat, lang);
      })
      .catch((e) => {
        // toast.error("Location not allowed")
        GetInfo(getinfoCallback, getinfoErrorCallback);
      });
  };

  const getinfoCallback = (lat, lang) => {
    setLat(Number(lat));
    setLong(Number(lang));
    onPlaceChangedNew(lat, lang);
  };
  const getinfoErrorCallback = (lat, lng) => {
    setLoaded(false);
  };

  const onPlaceChangedNew = async (lats, longs) => {
    try {
      const lat = Number(lats);
      const lang = Number(longs);
      const size = 10;
      setLoaded(false);
      if (lat && lang) {
        await getLocationData(lat, lang, "");
        await getCoordinates(lat, lang, size);
        setLat(lat);
        setLong(lang);
      }
      setLoaded(true);
    } catch (error) {
      console.log(error);
      getCurrentLocation();
    }
  };
  const onPlaceChanged = () => {

    if (autocompleted !== null) {
      try {
        setSkeletonLoading(true);
        setTimeout(() => {
          setSkeletonLoading(false);
        }, 2000);
        const lat = Number(autocompleted.getPlace()?.geometry?.location.lat());
        const lang = Number(autocompleted.getPlace()?.geometry?.location.lng());
        onPlaceChangedNew(lat, lang);
      } catch (error) {
        console.log(error);
        getCurrentLocation();
      }
    } else {
    }
  };
  const locateCurrentPosition = () =>
    new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve(position);
        },
        (error) => {
          console.log(error.message);
          reject(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 1000,
        }
      );
    });
  useEffect(() => {

    if (globalData.locationData?.data) {
      setLocationText(globalData.locationData.data.EmirateArea);
      setLat(globalData.locationData.lat)
      setLong(globalData.locationData.lng)
    }
  }, [globalData.locationData?.data]);
  const handleSubmitFormModal = async (data) => {


    const payload = {
      WorkshopName: data.WorkshopName,
      ContactPersonName: data.ContactName,
      PhoneNumber: data.PhoneNumber,
      Email: data.Email,
      LocationName: locationText,
      LocationLongitute: long,
      LocationLatitude: lat
    }
    console.log("Form Data: ", data);
    await API.post(`v2/api/workshop-request-leads`, payload, {
      headers: {
        // Authorization: "bearer " + token.access_token,
      },
    })
      .then(async (res) => {


        console.log(res);
        toast.dismiss();
        reset()
        toast.success("Form submitted successfully!");
        onClose()
      })
      .catch((err) => {

        console.log("Error ", err);
        toast.dismiss();
        toast.error("Something went wrong! Please retry.");
      });

  }
  return (
    <div className={`modal ${isOpen ? 'show' : ''}`} tabIndex="-1" style={{ display: isOpen ? 'block' : 'none', marginTop: '-1px', zIndex: 100 }}>
      <div className="modal-dialog modal-dialog-centered" style={{ height: '600px', paddingBottom: "100px" }}>
        <div className="modal-body">

          <form className="gr-contact-form modal-content " onSubmit={handleSubmit(handleSubmitFormModal)} >
            <div className="modal-close-button ">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <h4>Become an Open Bonnet Partner</h4>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Workshop Name <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                {...register("WorkshopName", { required: true })}
                onKeyPress={(event) => {
                  if (/\d/.test(event.key)) {
                    // test if the pressed key is a number
                    event.preventDefault(); // prevent the input of numeric values
                  }
                }}
                onPaste={(event) => {
                  const clipboardData =
                    event.clipboardData || window.clipboardData;
                  const pastedData = clipboardData.getData("text");
                  if (/\d/.test(pastedData)) {
                    // test if the clipboard contents contain numeric values
                    event.preventDefault(); // prevent the paste operation
                  }
                }}
              />
              {errors.WorkshopName && (
                <span className="text-danger   w-100" style={{ fontSize: "12px" }}>
                  Workshop Name is required.
                </span>
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="contactName" className="form-label">
                Contact Person Name <span>*</span>
              </label>
              <input
                type="text"
                name="ContactName"
                className="form-control"
                id="contactName"
                {...register("ContactName", { required: true })}
                onKeyPress={(event) => {
                  if (/\d/.test(event.key)) {
                    // test if the pressed key is a number
                    event.preventDefault(); // prevent the input of numeric values
                  }
                }}
                onPaste={(event) => {
                  const clipboardData =
                    event.clipboardData || window.clipboardData;
                  const pastedData = clipboardData.getData("text");
                  if (/\d/.test(pastedData)) {
                    // test if the clipboard contents contain numeric values
                    event.preventDefault(); // prevent the paste operation
                  }
                }}
              />
              {errors.ContactName && (
                <span className="text-danger   w-100" style={{ fontSize: "12px" }}>
                  Contact Person Name is required.
                </span>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="phoneNumber" className="form-label">
                Mobile Number <span>*</span>
              </label>
              <div className="mobile-num-input">
                <span>
                  <i>
                    <img
                      src="/assets/garage/call-in1.webp"
                      alt="Call Icon"
                    />
                  </i>
                  971
                </span>
                <input
                  type="text"

                  className="form-control"

                  onKeyDown={(e) => {
                    const isCtrlKey = e.ctrlKey || e.metaKey; // Check if "ctrl" or "cmd" key is pressed
                    const keyValue = e.key;
                    const numericRegex = /^[0-9]*$/;
                    if (
                      !(
                        numericRegex.test(keyValue) ||
                        isCtrlKey ||
                        keyValue === "Backspace"
                      )
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    const pastedValue = e.clipboardData.getData("text");
                    const numericRegex = /^[0-9]*$/;
                    if (!numericRegex.test(pastedValue)) {
                      e.preventDefault();
                    }
                  }}
                  onInput={(e) => {
                    if (e.target.value.length > e.target.maxLength)
                      e.target.value = e.target.value.slice(
                        0,
                        e.target.maxLength
                      );
                  }}
                  maxLength={9}
                  {...register("PhoneNumber", {
                    required: true,
                    validate: (value) => value[0] === "5" &&
                      (value[1] === "5" ||
                        value[1] === "2" ||
                        value[1] === "0" ||
                        value[1] === "6" ||
                        value[1] === "4" ||
                        value[1] === "8")
                      && value.length === 9,
                  })}
                />

              </div>
              {errors.PhoneNumber && (
                <span className="text-danger   w-100" style={{ fontSize: "12px" }}>
                  Enter valid mobile number.
                </span>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email Address <span>*</span>
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                id="email"
                {...register("Email", {
                  required: true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "invalid email address",
                  },
                })}
              />
              {errors.Email && (
                <span className="text-danger   w-100" style={{ fontSize: "12px" }}>
                  Email Address is required & valid
                </span>
              )}
            </div>

                  <div className="mb-3">
                    <label htmlFor="workshop" className="form-label">
                      Location <span>*</span>
                    </label>
                    <div className="gps-location">
                      <span>
                        <i onClick={getCurrentLocation}>
                          <img src="/assets/garage/gps.svg" alt="GPS Icon" />
                        </i>
                      </span>
                      {autocompleted ? (
                        <Autocomplete
                          onLoad={onLoading}
                          onPlaceChanged={onPlaceChanged}
                          types={"geocode"}
                          restrictions={{ country: ["AE"] }}
                        >
                          <input
                            type="text"
                            id="workshop"
                            placeholder="Search Location"
                            className="form-control"
                            ref={ref}
                            value={locationText}
                            onChange={(e) => setLocationText(e.target.value)}
                          />
                        </Autocomplete>
                      ) : (
                        <input
                          type="text"
                          id="workshop"
                          placeholder="Search Location"
                          className="form-control"
                          ref={ref}
                          value={locationText}
                          onChange={(e) => setLocationText(e.target.value)}
                        />
                      )}
                    </div>
                  </div>

            <div className="submit-btn-contrl mt-0">
              <button
                type="submit"
                className="btn btn-orange-sbtn submit-btn pt-0"
                disabled={isSubmitting}
              >
                Submit
              </button>
            </div>

            {/* <h4>Become an Open Bonnet Partner</h4>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">Workshop Name <span>*</span></label>
                            <input type="text" className="form-control" id="name" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">Contact Person Name <span>*</span></label>
                            <input type="text" className="form-control" id="email" />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">Mobile Number <span>*</span></label>
                            <div className="mobile-num-input">
                                <span><i><img src="/assets/garage/call-in.svg" alt="Call In" /></i>971</span>
                                <input type="text" className="form-control" id="email" />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">Email Address <span>*</span></label>
                            <input type="email" className="form-control" id="email" />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">Location <span>*</span></label>
                            <div className="gps-location">
                                <span><i><img src="/assets/garage/gps.svg" alt="GPS" /></i></span>
                                <input type="text" className="form-control" id="email" />
                            </div>
                        </div>

                        <div className="submit-btn-contrl">
                            <button type="submit" className="btn btn-orange-sbtn">Submit</button>
                        </div> */}
          </form>

        </div>
      </div>
    </div>
  );
};

export default GarageModal;
